<kendo-formfield appearance="fill" class="k-w-full">
  @if (showLabel()) {
    <kendo-label>{{ 'Tactical.Market' | translate }}</kendo-label>
  }
  <kendo-dropdownlist
    [defaultItem]="defaultItem"
    [data]="marketData"
    textField="name"
    valueField="marketId"
    [value] = "selectedMarketId"
    [valuePrimitive]="true"
    (valueChange)="onSelect($event)">
  </kendo-dropdownlist>
</kendo-formfield>
